import React, { Suspense, useContext, useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { routes } from './RouteConstant';
import Header from '../Component/CommonComponent/Header/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import LanguageContext from './LanguageContext';

const AppContents = () => {
  const { language } = useContext(LanguageContext);

  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        <Header />
        <Routes>
          {routes.map((route, idx) => {
            if (route.element) {
              return (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  element={
                    <React.Suspense fallback={<div className='modal-loader'>
                      {language === 'en' ? 'Loading...' : '로딩 중...'}
                      <FontAwesomeIcon icon={faSpinner} className="fa-spinner" />
                    </div>}>
                      <route.element />
                    </React.Suspense>
                  }
                />
              );
            }
            return null;
          })}
        </Routes>
      </Suspense>
    </div>
  );
};

export default AppContents;
